import { createStyled } from './createStyled';
import { deprecatedCss } from './deprecatedCss';
/** @deprecated */ export const deprecatedStyled = createStyled(deprecatedCss);

//# sourceMappingURL=styled.js.map